import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { patch } from "../../lib/sessionClient";
import { clearLocalStorageSession } from "../../lib/authUtils";

const usePatchData = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState("");
  const [successResponse, setSuccessResponse] = useState(null);

  const executePatch = async (sendData, apiUrl, updateStateOnResponse) => {
    setLoading(true);
    setFormError("")
    try {
      const response = await patch(apiUrl, sendData);
      setSuccessResponse(response.data);
      updateStateOnResponse?.();
    } catch (error) {
      if (error.response && error.response.status === 401) {
        clearLocalStorageSession();
        navigate("/login");
      } else {
        setFormError(error.response?.data?.message || error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    executePatch,
    loading,
    formError,
    successResponse,
    setFormError,
    setSuccessResponse,
  };
};

export default usePatchData;
